(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["index~menu~tree"],{

/***/ 102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _css_animation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39);
/* harmony import */ var raf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14);
/* harmony import */ var raf__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(raf__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_2__);




function animate(node, show, done) {
  var height;
  var requestAnimationFrameId;
  var appearRequestAnimationFrameId;
  return Object(_css_animation__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(node, "ant-motion-collapse-legacy", {
    start: function start() {
      if (appearRequestAnimationFrameId) {
        raf__WEBPACK_IMPORTED_MODULE_1___default.a.cancel(appearRequestAnimationFrameId);
      }

      if (!show) {
        node.style.height = "".concat(node.offsetHeight, "px");
        node.style.opacity = "1";
      } else {
        height = node.offsetHeight; // not get offsetHeight when appear
        // set it into raf get correct offsetHeight

        if (height === 0) {
          appearRequestAnimationFrameId = raf__WEBPACK_IMPORTED_MODULE_1___default()(function () {
            height = node.offsetHeight;
            node.style.height = "0px";
            node.style.opacity = "0";
          });
        } else {
          node.style.height = "0px";
          node.style.opacity = "0";
        }
      }
    },
    active: function active() {
      if (requestAnimationFrameId) {
        raf__WEBPACK_IMPORTED_MODULE_1___default.a.cancel(requestAnimationFrameId);
      }

      requestAnimationFrameId = raf__WEBPACK_IMPORTED_MODULE_1___default()(function () {
        node.style.height = "".concat(show ? height : 0, "px");
        node.style.opacity = show ? "1" : "0";
      });
    },
    end: function end() {
      if (appearRequestAnimationFrameId) {
        raf__WEBPACK_IMPORTED_MODULE_1___default.a.cancel(appearRequestAnimationFrameId);
      }

      if (requestAnimationFrameId) {
        raf__WEBPACK_IMPORTED_MODULE_1___default.a.cancel(requestAnimationFrameId);
      }

      node.style.height = "";
      node.style.opacity = "";
      done && done();
    }
  });
}

var animation = {
  enter: function enter(node, done) {
    vue__WEBPACK_IMPORTED_MODULE_2___default.a.nextTick(function () {
      animate(node, true, done);
    });
  },
  leave: function leave(node, done) {
    return animate(node, false, done);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (animation);

/***/ })

}]);